var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"conversation-badge"},on:{"click":_vm.openChat}},[_c('Icon',{attrs:{"tooltip":_vm.opened ? 'Fechar suporte' : 'Abrir suporte'}},[_c('SupportIcon',{staticClass:"icon",attrs:{"id":"suport-icon"}})],1),(_vm.unreadIndicator)?_c('div',{staticClass:"unread-indicator"},[_vm._v(" "+_vm._s(_vm.unreadIndicator)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }